export class MessageCondition {

  constructor() {
    this.typeCode = null;
    this.parameters = null;
  }

  setTypeCode(typeCode) {
    this.typeCode = typeCode;
    if (typeCode) {
      this.parameters = MessageConditionType.forCode(typeCode).defaultParamsFn();
    }
  }

  isTypeSite() {
    return this.typeCode === _TYPE_CODES.SITE;
  }
  isTypeChannel() {
    return this.typeCode === _TYPE_CODES.CHANNEL;
  }
  isHelpRequestAnswered() {
    return this.typeCode === _TYPE_CODES.HELP_REQUEST_ANSWERED;
  }
  isAutoAssigned() {
    return this.typeCode === _TYPE_CODES.AUTO_ASSIGNED;
  }
  isTypeOlderThan() {
    return this.typeCode === _TYPE_CODES.OLDER_THAN;
  }
  isTypeYoungerThan() {
    return this.typeCode === _TYPE_CODES.YOUNGER_THAN;
  }
  isTypeWeekDay() {
    return this.typeCode === _TYPE_CODES.WEEK_DAY;
  }
  isTypeBhNbh() {
    return this.typeCode === _TYPE_CODES.BH_NBH;
  }
  isTypeKeywords() {
    return this.typeCode === _TYPE_CODES.KEYWORDS;
  }
  isTypeExcludeKeywords() {
    return this.typeCode === _TYPE_CODES.EXCLUDE_KEYWORDS;
  }
  isTypeMessageIs() {
    return this.typeCode === _TYPE_CODES.MESSAGE_IS;
  }
  isTypeMessageWithNoContent() {
    return this.typeCode === _TYPE_CODES.MESSAGE_WITH_NO_CONTENT;
  }
  isTypeMessageWithOnlyEmojis() {
    return this.typeCode === _TYPE_CODES.MESSAGE_WITH_ONLY_EMOJIS;
  }
  isTypeVip() {
    return this.typeCode === _TYPE_CODES.VIP;
  }
  isTypeMinFollowers() {
    return this.typeCode === _TYPE_CODES.MIN_FOLLOWERS;
  }
  isTypeTag() {
    return this.typeCode === _TYPE_CODES.TAG;
  }
  isTypeFirstOfConversation() {
    return this.typeCode === _TYPE_CODES.FIRST_OF_CONVERSATION;
  }
  isTypeConversationAlreadyAnswered() {
    return this.typeCode === _TYPE_CODES.CONVERSATION_ALREADY_ANSWERED;
  }
  isTypeAnswerToPublication() {
    return this.typeCode === _TYPE_CODES.IS_ANSWER_TO_PUBLICATION;
  }
  isTypeContainsExclusivelyMention() {
    return this.typeCode === _TYPE_CODES.CONTAINS_EXCLUSIVELY_MENTION;
  }
  isTypeIsFromCustomerChatGuestUser() {
    return this.typeCode === _TYPE_CODES.IS_FROM_CUSTOMER_CHAT_GUEST_USER;
  }
  isTypeIsPublicationCommentWithKeywords() {
    return this.typeCode === _TYPE_CODES.IS_PUBLICATION_COMMENT_WITH_KEYWORDS;
  }
  isTypeCustomField() {
    return this.typeCode === _TYPE_CODES.CUSTOM_FIELD;
  }
  isTypeRating() {
    return this.typeCode === _TYPE_CODES.RATING;
  }

  static fromBackEnd(backendCondition) {
    const result = new MessageCondition();
    result.typeCode = backendCondition.typeCode;
    result.parameters = angular.copy(backendCondition.parameters);
    return result;
  }
}


export class MessageConditionType {

  constructor(code, defaultParamsFn) {
    this.code = code;
    this.defaultParamsFn = defaultParamsFn;
  }

  static codes() {
    return _messageConditionTypes.map(t => t.code);
  }

  static values() {
    return _messageConditionTypes;
  }

  static forCode(code) {
    return _messageConditionTypes.filter(t => t.code === code)[0];
  }
}

const _TYPE_CODES = {
  SITE: 'site',
  CHANNEL: 'channel',
  HELP_REQUEST_ANSWERED: 'help-request-answered',
  AUTO_ASSIGNED: 'auto-assigned',
  OLDER_THAN: 'older-than',
  YOUNGER_THAN: 'younger-than',
  WEEK_DAY: 'week-day',
  BH_NBH: 'bh-nbh',
  KEYWORDS: 'keywords',
  EXCLUDE_KEYWORDS: 'exclude-keywords',
  MESSAGE_IS: 'message-is',
  MESSAGE_WITH_NO_CONTENT: 'message-with-no-content',
  MESSAGE_WITH_ONLY_EMOJIS: 'message-with-only-emojis',
  VIP: 'vip',
  MIN_FOLLOWERS: 'min-followers',
  TAG: 'tag',
  FIRST_OF_CONVERSATION: 'first-of-conversation',
  CONVERSATION_ALREADY_ANSWERED: 'conversation-already-answered',
  IS_ANSWER_TO_PUBLICATION: 'message-from-post',
  CONTAINS_EXCLUSIVELY_MENTION: 'contains-exclusively-mention',
  IS_FROM_CUSTOMER_CHAT_GUEST_USER: 'is-from-customer-chat-guest-user',
  IS_PUBLICATION_COMMENT_WITH_KEYWORDS: 'is-publication-comment-with-keywords',
  MESSAGE_WITH_ONLY_NON_BRAND_MENTIONS_AND_EMOJIS: 'message-with-brand-mentions-only-and-emojis',
  CUSTOM_FIELD: 'custom-field',
  MANUALLY_ASSIGNED: 'manually-assigned',
  RATING: 'rating',
  SHOPPING_ENTRYPOINT: 'shopping-entrypoint',
  IS_1_TO_1_ENGAGEMENT: 'is-1-to-1-engagement',
}

const _messageConditionTypes = [
  new MessageConditionType(_TYPE_CODES.SITE, () => ({ 'siteIds': [] })),                    // {'siteIds': [int]}
  new MessageConditionType(_TYPE_CODES.CHANNEL, () => ({ 'taskTypes': [] })),                  // {'taskTypes': [int]}
  new MessageConditionType(_TYPE_CODES.HELP_REQUEST_ANSWERED, () => ({})),                                 // {}
  new MessageConditionType(_TYPE_CODES.AUTO_ASSIGNED, () => ({})),                                 // {}
  new MessageConditionType(_TYPE_CODES.OLDER_THAN, () => ({ 'hours': null })),                    // {'hours': int}
  new MessageConditionType(_TYPE_CODES.YOUNGER_THAN, () => ({ 'hours': null })),                    // {'hours': int}
  new MessageConditionType(_TYPE_CODES.WEEK_DAY, () => ({ 'days': [] })),                       // {'days': [0|1|2|3|4|5|6]}
  new MessageConditionType(_TYPE_CODES.BH_NBH, () => ({ 'hours': [] })),                      // {'hours': ['bh'|'nbh']}
  new MessageConditionType(_TYPE_CODES.KEYWORDS, () => ({ 'keywords': [] })),                   // {'keywords': [string]}
  new MessageConditionType(_TYPE_CODES.EXCLUDE_KEYWORDS, () => ({ 'keywords': [] })),                   // {'keywords': [string]}
  new MessageConditionType(_TYPE_CODES.MESSAGE_IS, () => ({ 'message-is': null })),               // {'message-is': string}
  new MessageConditionType(_TYPE_CODES.MESSAGE_WITH_NO_CONTENT, () => ({})),                                 // {}
  new MessageConditionType(_TYPE_CODES.MESSAGE_WITH_ONLY_EMOJIS, () => ({})),                                 // {}
  new MessageConditionType(_TYPE_CODES.VIP, () => ({})),                                 // {}
  new MessageConditionType(_TYPE_CODES.MIN_FOLLOWERS, () => ({ 'followers': null })),                // {'followers': int}
  new MessageConditionType(_TYPE_CODES.TAG, () => ({ 'tagGroupId': null, 'tagIds': [] })), // {'tagGroupId': int, 'tagIds': [int]}
  new MessageConditionType(_TYPE_CODES.FIRST_OF_CONVERSATION, () => ({})),                                 // {}
  new MessageConditionType(_TYPE_CODES.CONVERSATION_ALREADY_ANSWERED, () => ({})),                                 // {}
  new MessageConditionType(_TYPE_CODES.IS_ANSWER_TO_PUBLICATION, () => ({ 'siteId': null, 'postId': null, 'content': null, 'date': null, 'externalUrl': null })),
  new MessageConditionType(_TYPE_CODES.CONTAINS_EXCLUSIVELY_MENTION, () => ({})),
  new MessageConditionType(_TYPE_CODES.IS_FROM_CUSTOMER_CHAT_GUEST_USER, () => ({})),
  new MessageConditionType(_TYPE_CODES.IS_PUBLICATION_COMMENT_WITH_KEYWORDS, () => ({ 'keywords': [] })),                // {'keywords': [string]}
  new MessageConditionType(_TYPE_CODES.MESSAGE_WITH_ONLY_NON_BRAND_MENTIONS_AND_EMOJIS, () => ({})),          // {}
  new MessageConditionType(_TYPE_CODES.CUSTOM_FIELD, () => ({})),
  new MessageConditionType(_TYPE_CODES.MANUALLY_ASSIGNED, () => ({})),
  new MessageConditionType(_TYPE_CODES.RATING, () => ({})),
  new MessageConditionType(_TYPE_CODES.SHOPPING_ENTRYPOINT, () => ({})),
  new MessageConditionType(_TYPE_CODES.IS_1_TO_1_ENGAGEMENT, () => ({})),

];
